import { ENV } from './environment';

export const NETWORKS = {
    mainnet: {
        chainId: 8453,
        name: 'Base',
        currency: 'ETH',
        explorerUrl: 'https://basescan.org',
        rpcUrl: `https://base-mainnet.g.alchemy.com/v2/${ENV.ALCHEMY_KEY}`,
        nativeCurrency: {
            name: 'Ether',
            symbol: 'ETH',
            decimals: 18
        },
        rpcUrls: [
            `https://base-mainnet.g.alchemy.com/v2/${ENV.ALCHEMY_KEY}`,
            'https://mainnet.base.org',
            'https://1rpc.io/base',
            'https://base.gateway.tenderly.co',
            'https://base.publicnode.com'
        ],
    },
    testnet: {
        chainId: 84532,
        name: 'Base Sepolia',
        currency: 'ETH',
        explorerUrl: 'https://sepolia.basescan.org',
        // rpcUrl: `https://base-sepolia.infura.io/v3/${ENV.INFURA_KEY}`,
        rpcUrl: `https://base-sepolia.g.alchemy.com/v2/${ENV.ALCHEMY_KEY}`,
        nativeCurrency: {
            name: 'Ether',
            symbol: 'ETH',
            decimals: 18
        },
        // Additional parameters for testnet
        networkId: 84532,
        iconUrls: [], // Optional: Add icon URLs if you have them
        // Fallback RPC URLs in case primary fails
        rpcUrls: [
            `https://base-sepolia.g.alchemy.com/v2/${ENV.ALCHEMY_KEY}`,
            'https://sepolia.base.org',
            'https://1rpc.io/base-sepolia'
        ]
    }
};

export const CHAIN_OPTIONS = [
    { value: 'Base', chainNo: 3 },
    { value: 'Arbitrum', chainNo: 1 },
    { value: 'Optimism', chainNo: 2 },
    { value: 'Linea', chainNo: 4 },
    { value: 'Solana', chainNo: 5 },
    { value: 'Zksync', chainNo: 6 },
    { value: 'Mantle', chainNo: 7 },
    { value: 'Mode', chainNo: 8 }
];

export const CHAIN_MAPPING = CHAIN_OPTIONS.reduce((acc, { value, chainNo }) => {
    acc[value] = chainNo;
    return acc;
}, {});